export default "__VITE_ASSET__C6SqOJQx__"